/**
 * THE PRODUCT PAGE'S OWN BEHAVIOUR (2026-09-17, the owner's variant B).
 *
 * Everything here is an enhancement of markup that already works without it:
 *
 *   zoom     the control in the frame's corner forwards its click to the
 *            photograph on screen, which is what the theme's viewer listens
 *            for - so no second viewer, and nothing to keep in step
 *   strip    the "+N" tile at the end of the thumbnail strip scrolls the
 *            strip to its end
 *   tabs     the tabs are plain anchors to the panels below them, and every
 *            panel is open, until this file marks the page .bc-pdp--tabs and
 *            shows one at a time. A panel is chosen by click, by the address
 *            bar's #hash on arrival, and by the keyboard's arrow keys; the
 *            hash is written with replaceState, so the page never jumps and
 *            the back button is not filled with tab changes
 *
 * The gallery's own switching, loading and active mark stay in
 * assets/bc-product-gallery.js; this file never touches a photo's src.
 */
(function () {
  'use strict';

  function shownPhoto(root) {
    var wrappers = root.querySelectorAll('.product-single__featured-image-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      if (!wrappers[i].classList.contains('hidden')) return wrappers[i].querySelector('.product-single__photo');
    }
    return root.querySelector('.product-single__photo');
  }

  function bindZoom(root) {
    var button = root.querySelector('[data-bc-pgal-zoom]');
    if (!button) return;

    button.addEventListener('click', function () {
      var photo = shownPhoto(root);
      if (photo) photo.click();
    });
  }

  function thumbsOf(root) {
    return root.querySelectorAll('.product-single__thumbnail');
  }

  function activeThumb(thumbs) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('bc-pgal__thumb--active')) return i;
    }
    return 0;
  }

  /* The gallery script marks the active thumbnail and nothing else here keeps
     a second idea of which photo is on screen - the rail, the counter and the
     phone's dots all watch that one mark. */
  function watchThumbs(thumbs, fn) {
    if (!window.MutationObserver) return;
    var watcher = new MutationObserver(fn);
    for (var i = 0; i < thumbs.length; i++) {
      watcher.observe(thumbs[i], { attributes: true, attributeFilter: ['class'] });
    }
  }

  function smooth() {
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /*
    THE RAIL (2026-09-22): the thumbnails stand in a column beside the frame
    and scroll behind two arrows. The arrows move the rail by a screenful
    less one thumbnail, so the shopper never loses their place, and each one
    is away while the rail is against that end. The photograph on screen is
    always brought into the rail - a variant switch changes it without anyone
    touching a thumbnail.
  */
  function bindRail(root) {
    var rail = root.querySelector('[data-bc-pgal-rail]');
    var strip = root.querySelector('[data-bc-pgal-strip]');
    if (!rail || !strip) return;

    var up = rail.querySelector('[data-bc-pgal-rail-up]');
    var down = rail.querySelector('[data-bc-pgal-rail-down]');
    var thumbs = thumbsOf(root);
    var EDGE = 26; /* the arrow's 24px and the hairline under it */

    /* The rail stands beside the frame from 1200 and lies under it below
       that (assets/bc-product-gallery.css), so the axis is read from the
       rail itself rather than from a width this file would have to keep in
       step with the stylesheet. */
    var across = function () {
      return window.getComputedStyle(strip).flexDirection === 'row';
    };
    var pos = function () { return across() ? strip.scrollLeft : strip.scrollTop; };
    var view = function () { return across() ? strip.clientWidth : strip.clientHeight; };
    var content = function () { return across() ? strip.scrollWidth : strip.scrollHeight; };

    var scrollTo = function (to) {
      var limit = content() - view();
      if (to < 0) to = 0;
      if (to > limit) to = limit;
      var how = { behavior: smooth() ? 'smooth' : 'auto' };
      if (across()) how.left = to; else how.top = to;
      if (strip.scrollTo) strip.scrollTo(how);
      else if (across()) strip.scrollLeft = to;
      else strip.scrollTop = to;
    };

    var refresh = function () {
      var over = content() > view() + 1;
      if (up) up.hidden = !over || pos() <= 1;
      if (down) down.hidden = !over || pos() + view() >= content() - 1;
    };

    var step = function () {
      return Math.max(80, view() - 80);
    };

    if (up) up.addEventListener('click', function () { scrollTo(pos() - step()); });
    if (down) down.addEventListener('click', function () { scrollTo(pos() + step()); });
    strip.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', function () {
      window.clearTimeout(rail.bcTimer);
      rail.bcTimer = window.setTimeout(function () { refresh(); follow(); }, 150);
    });

    var follow = function () {
      var item = thumbs[activeThumb(thumbs)];
      item = item && item.parentNode;
      if (!item || !view()) return;
      var start = across() ? item.offsetLeft : item.offsetTop;
      var end = start + (across() ? item.offsetWidth : item.offsetHeight);
      if (start < pos() + EDGE) scrollTo(start - EDGE);
      else if (end > pos() + view() - EDGE) scrollTo(end - view() + EDGE);
    };

    watchThumbs(thumbs, function () { follow(); refresh(); });
    refresh();
    follow();
  }

  /*
    THE FRAME'S ARROWS AND ITS COUNTER (2026-09-22). Both press a thumbnail,
    so the switch stays in one place; the arrows wrap round the ends, which
    is what a shopper stepping through a set of photographs expects. The left
    and right keys do the same while the keyboard is anywhere in the gallery -
    except in a field, where the keys belong to the text.
  */
  function bindFrameNav(root) {
    var thumbs = thumbsOf(root);
    if (thumbs.length < 2) return;

    var prev = root.querySelector('[data-bc-pgal-prev]');
    var next = root.querySelector('[data-bc-pgal-next]');
    var counter = root.querySelector('[data-bc-pgal-current]');

    var go = function (delta) {
      var n = activeThumb(thumbs) + delta;
      if (n < 0) n = thumbs.length - 1;
      if (n >= thumbs.length) n = 0;
      thumbs[n].click();
    };

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var sync = function () {
      if (counter) counter.textContent = String(activeThumb(thumbs) + 1);
    };
    watchThumbs(thumbs, sync);
    sync();

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      var target = e.target;
      var tag = target && target.tagName;
      if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA' || (target && target.isContentEditable)) return;
      e.preventDefault();
      go(e.key === 'ArrowLeft' ? -1 : 1);
    });
  }

  function bindTabs(tabs) {
    var list = tabs.querySelectorAll('[data-bc-tab]');
    var panels = tabs.querySelectorAll('[data-bc-panel]');
    if (!list.length || !panels.length) return;

    var show = function (id, focusPanel) {
      var found = false;
      for (var i = 0; i < panels.length; i++) {
        var on = panels[i].id === id;
        panels[i].classList.toggle('is-active', on);
        if (on) found = true;
      }
      if (!found) return false;

      for (var j = 0; j < list.length; j++) {
        var active = list[j].getAttribute('aria-controls') === id;
        list[j].classList.toggle('is-active', active);
        list[j].setAttribute('aria-selected', active ? 'true' : 'false');
        list[j].setAttribute('tabindex', active ? '0' : '-1');
      }

      if (focusPanel) {
        var panel = document.getElementById(id);
        if (panel) panel.focus({ preventScroll: true });
      }
      syncHeadings();
      return true;
    };

    /*
      THE ACCORDION. Where the four labels do not fit on one line - 425px of
      them against the 345px a 375px phone gives, measured - the row folds
      away and each panel's own heading becomes its handle. The row is
      measured rather than guessed at a breakpoint, so a shorter set of
      labels, or a bigger phone, keeps the tabs.
    */
    var row = tabs.querySelector('.bc-pdp__tablist');

    /* A heading is a control only while the accordion is folded. On a wide
       screen it is a hidden heading again and carries no button role, so a
       screen reader is not offered a control that does nothing. */
    function syncHeadings() {
      var folded = tabs.classList.contains('bc-pdp--accordion');
      for (var p = 0; p < panels.length; p++) {
        var head = panels[p].querySelector('.bc-pdp__panel-heading');
        if (!head) continue;
        if (folded) {
          head.setAttribute('role', 'button');
          head.setAttribute('tabindex', '0');
          head.setAttribute('aria-expanded', panels[p].classList.contains('is-active') ? 'true' : 'false');
        } else {
          head.removeAttribute('role');
          head.removeAttribute('tabindex');
          head.removeAttribute('aria-expanded');
        }
      }
    }

    for (var m = 0; m < panels.length; m++) {
      (function (panel) {
        var head = panel.querySelector('.bc-pdp__panel-heading');
        if (!head) return;

        var toggle = function () {
          /* On a wide screen the heading is not a control - the row is. */
          if (!tabs.classList.contains('bc-pdp--accordion')) return;
          panel.classList.toggle('is-active');
          syncHeadings();
        };

        head.addEventListener('click', toggle);
        head.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          e.preventDefault();
          toggle();
        });
      })(panels[m]);
    }

    var fold = function () {
      if (!row) return;
      /* The row has to be on screen to be measured, so the class comes off
         first; a folded row reports a width of nothing. */
      tabs.classList.remove('bc-pdp--accordion');
      if (row.scrollWidth > row.clientWidth + 1) tabs.classList.add('bc-pdp--accordion');
      syncHeadings();
    };

    var folding = false;
    window.addEventListener('resize', function () {
      if (folding) return;
      folding = true;
      window.requestAnimationFrame(function () { folding = false; fold(); });
    });

    for (var k = 0; k < list.length; k++) {
      (function (tab, index) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          var id = tab.getAttribute('aria-controls');
          if (!show(id, false)) return;
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#' + id);
          }
        });

        tab.addEventListener('keydown', function (e) {
          var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          e.preventDefault();
          var next = list[(index + step + list.length) % list.length];
          next.focus();
          show(next.getAttribute('aria-controls'), false);
        });
      })(list[k], k);
    }

    tabs.classList.add('bc-pdp--tabs');

    /* An address that names a panel opens on it; anything else opens on the
       first tab, which is the description. */
    var hash = window.location.hash ? window.location.hash.slice(1) : '';
    if (!hash || !show(hash, false)) show(panels[0].id, false);

    fold();

    window.addEventListener('hashchange', function () {
      var id = window.location.hash ? window.location.hash.slice(1) : '';
      if (id) show(id, true);
    });

    /* A link elsewhere on the page (the rating in the buy card) can open a
       panel by pointing at it. */
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href^="#bc-tab-"]') : null;
      if (!link || link.hasAttribute('data-bc-tab')) return;
      var id = link.getAttribute('href').slice(1);
      if (show(id, true)) {
        e.preventDefault();
        tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#' + id);
      }
    });
  }

  /*
    The pills are a face for the control the page already switches the
    product through. Shopify's option_selection.js builds a
    .single-option-selector for the option and drives everything from it -
    the price, the photograph, the button, the address - so a press writes
    the option into that dropdown and fires its change. Nothing about the
    cart path changes, and the hidden select the form posts is still set by
    the library, not by this file.

    The dropdown is built after this file runs, so it is looked up at the
    moment of the press rather than kept.
  */
  /*
    THE SAVING AND THE COUNT (2026-09-23). Both lines were rendered for
    every variant by the section - the saving because money must go through
    the theme's filter, which wraps the figure in .hidePrice - so this only
    chooses which pair to show when the variant changes. A variant the map
    does not carry, or a line the section left empty, hides its line rather
    than guessing.
  */
  function bindSelling(section) {
    var box = section.querySelector('[data-bc-selling]');
    var select = section.querySelector('select[name="id"]');
    if (!box || !select) return;

    var facts;
    try {
      facts = JSON.parse(box.getAttribute('data-bc-facts') || '[]');
    } catch (e) {
      return;
    }

    var saving = box.querySelector('[data-bc-saving]');
    var stock = box.querySelector('[data-bc-stock]');

    var put = function (node, html) {
      if (!node) return;
      node.innerHTML = html || '';
      node.hidden = !html;
    };

    var sync = function () {
      var id = String(select.value);
      var found = null;
      for (var i = 0; i < facts.length; i++) {
        if (String(facts[i].id) === id) found = facts[i];
      }
      put(saving, found && found.saving);
      put(stock, found && found.stock);
    };

    select.addEventListener('change', sync);
    /* option_selection.js writes the select without firing change on some
       paths; the pills' own click is the other way in. */
    section.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-bc-variant]')) window.setTimeout(sync, 0);
    });
  }

  function bindVariants(form) {
    var box = form.querySelector('[data-bc-pdp-variants]');
    if (!box) return;

    var pills = box.querySelectorAll('[data-bc-variant]');

    var mark = function (option) {
      for (var i = 0; i < pills.length; i++) {
        var on = pills[i].getAttribute('data-bc-option') === option;
        pills[i].classList.toggle('is-active', on);
        pills[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    };

    for (var i = 0; i < pills.length; i++) {
      (function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          var option = pill.getAttribute('data-bc-option');
          var dropdown = form.querySelector('.single-option-selector');

          if (dropdown) {
            dropdown.value = option;
            dropdown.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            /* No library on the page: set what the form posts, so the pill
               still chooses the variant. */
            var select = form.querySelector('select[name="id"]');
            if (select) {
              select.value = pill.getAttribute('data-bc-variant');
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          mark(option);
        });
      })(pills[i]);
    }

    /* Anything else that changes the option - the address bar on arrival,
       the browser's back button - and the pills follow it. */
    form.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('single-option-selector')) mark(e.target.value);
    });
  }

  /*
    THE PHONE'S GALLERY: a dot per photograph under the frame, and a swipe
    across the frame that moves one photograph. Both press a thumbnail -
    the gallery script's own control - so the loading, the decode and the
    active mark stay in one place.
  */
  function bindPhoneGallery(root) {
    var dots = root.querySelector('[data-bc-pgal-dots]');
    var thumbs = root.querySelectorAll('.product-single__thumbnail');
    if (!dots || thumbs.length < 2) return;

    for (var i = 0; i < thumbs.length; i++) {
      (function (thumb, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bc-pgal__dot';
        dot.setAttribute('aria-label', String(index + 1));
        dot.addEventListener('click', function () { thumb.click(); });
        dots.appendChild(dot);
      })(thumbs[i], i);
    }

    var sync = function () {
      var kids = dots.children;
      for (var j = 0; j < thumbs.length; j++) {
        if (kids[j]) kids[j].classList.toggle('is-active', thumbs[j].classList.contains('bc-pgal__thumb--active'));
      }
    };

    /* The gallery script marks the active thumbnail; the dots follow it
       rather than keeping a second idea of which photo is on screen. */
    if (window.MutationObserver) {
      var watcher = new MutationObserver(sync);
      for (var k = 0; k < thumbs.length; k++) watcher.observe(thumbs[k], { attributes: true, attributeFilter: ['class'] });
    }
    sync();
    if (!thumbs[0].classList.contains('bc-pgal__thumb--active') && dots.firstChild) dots.firstChild.classList.add('is-active');

    var frame = root.querySelector('.bc-pgal__frame');
    if (!frame) return;

    var startX = 0, startY = 0, tracking = false;
    frame.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    frame.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

      var current = 0;
      for (var n = 0; n < thumbs.length; n++) if (thumbs[n].classList.contains('bc-pgal__thumb--active')) current = n;
      var next = dx < 0 ? current + 1 : current - 1;
      if (next < 0 || next >= thumbs.length) return;
      thumbs[next].click();
    }, { passive: true });
  }

  /*
    THE BUY BAR: it copies the real button rather than being one. It is
    shown while Add to cart is off the screen above, on phones and tablets
    only, and its label, its price and its disabled state are read from the
    page's own elements whenever they change.
  */
  function bindBar(section) {
    var bar = section.querySelector('[data-bc-pdp-bar]');
    var add = section.querySelector('#AddToCart');
    var label = section.querySelector('#AddToCartText');
    var price = section.querySelector('#ProductPrice');
    var select = section.querySelector('select[name="id"]');
    if (!bar || !add) return;

    var barAdd = bar.querySelector('[data-bc-bar-add]');
    var barPrice = bar.querySelector('[data-bc-bar-price]');
    var barVariant = bar.querySelector('[data-bc-bar-variant]');
    var wide = window.matchMedia('(min-width: 1024px)');

    barAdd.addEventListener('click', function () { add.click(); });

    var copy = function () {
      if (label) barAdd.textContent = label.textContent.trim();
      barAdd.disabled = add.disabled;
      if (barPrice && price) barPrice.textContent = price.textContent.trim();
      if (barVariant && select && select.options[select.selectedIndex]) {
        barVariant.textContent = select.options[select.selectedIndex].text.split(' - ')[0].trim();
      }
    };

    var show = function (on) {
      bar.hidden = !on || wide.matches;
    };

    /*
      Read on scroll rather than through an IntersectionObserver: the
      observer reports a CHANGE of intersection, and a jump - an anchor, a
      restored position, a tap on a tab - can take Add to cart from below
      the screen to above it without it ever being on the screen, which is
      no change at all and no callback (measured: the bar stayed away after
      a jump of 2,100px). Above the screen means the shopper has read past
      the button; below it they have not reached it yet, and the bar would
      be noise.
    */
    var ticking = false;
    var measure = function () {
      ticking = false;
      show(add.getBoundingClientRect().bottom < 0);
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    measure();

    if (window.MutationObserver) {
      var watcher = new MutationObserver(copy);
      if (label) watcher.observe(label, { childList: true, characterData: true, subtree: true });
      if (price) watcher.observe(price, { childList: true, characterData: true, subtree: true });
      watcher.observe(add, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
    if (select) select.addEventListener('change', function () { window.setTimeout(copy, 60); });

    if (wide.addEventListener) wide.addEventListener('change', function () { if (wide.matches) bar.hidden = true; });
    copy();
  }

  function init() {
    var forms = document.querySelectorAll('.bc-pdp__form');
    for (var f = 0; f < forms.length; f++) {
      if (forms[f].dataset.bcVariantsBound === 'true') continue;
      forms[f].dataset.bcVariantsBound = 'true';
      bindVariants(forms[f]);
    }

    var roots = document.querySelectorAll('[data-bc-product-gallery]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.bcPdpBound === 'true') continue;
      roots[i].dataset.bcPdpBound = 'true';
      bindZoom(roots[i]);
      bindRail(roots[i]);
      bindFrameNav(roots[i]);
      bindPhoneGallery(roots[i]);
    }

    var sections = document.querySelectorAll('[data-section-type="product-template"]');
    for (var s = 0; s < sections.length; s++) {
      if (sections[s].dataset.bcBarBound === 'true') continue;
      sections[s].dataset.bcBarBound = 'true';
      bindBar(sections[s]);
      bindSelling(sections[s]);
    }

    var tabs = document.querySelectorAll('[data-bc-tabs]');
    for (var t = 0; t < tabs.length; t++) {
      if (tabs[t].dataset.bcTabsBound === 'true') continue;
      tabs[t].dataset.bcTabsBound = 'true';
      bindTabs(tabs[t]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
